var map = {
	"./global-energy-co2-data.jpg": 511,
	"./world-energy-trends-cover-2023.jpg": 512,
	"./world-energy-trends-cover-2024.jpg": 513,
	"./world-energy-trends-cover-2025.jpg": 514,
	"./world-energy-trends-cover.jpg": 515
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 510;